import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React, { useMemo } from 'react';

export interface RiskRatingProps {
  currentRiskRating: number;
  maxRiskRating?: number;
  tooltip?: string;
}

export const RiskRating: React.FC<RiskRatingProps> = ({
  currentRiskRating,
  maxRiskRating = 5,
  tooltip,
}) => {
  const riskRating = Array.from({ length: maxRiskRating }, (_, i) => i + 1);

  const riskRatingIcons = useMemo(
    () => (
      <HStack space={Spacing['inline.nano']}>
        {riskRating.map((risk) => (
          <UI.Icon
            key={risk.toString()}
            name="Circle"
            size="xxxxxs"
            color={Color[risk <= currentRiskRating ? 'neutral.darkest' : 'neutral.lightest']}
          />
        ))}
      </HStack>
    ),
    [currentRiskRating, riskRating]
  );

  if (tooltip) {
    return <UI.Tooltip label={tooltip}>{riskRatingIcons}</UI.Tooltip>;
  }

  return riskRatingIcons;
};
